import { render } from "./Email.svg?vue&type=template&id=22d19944"
const script = {}
script.render = render

export default script